var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useSiteMetadata } from '../hooks/use-site-metadata';
import { useSite } from '../hooks/use-site';
import { useEntity } from '../hooks/use-entity';
import { useCopyToClipboard } from '../hooks/use-copy-to-clipboard';
import { sprintf } from 'sprintf-js';
import { MenuItem } from './menu-item';
import { EntityBubbleImage } from '../entities/entity-bubble-image';
import { FacebookFilledIconGlyph, XFilledIconGlyph, LinkedinFilledIconGlyph, EmailFilledIconGlyph, TickIconGlyph } from '@shapeable/icons';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { SiteMenuTitle } from '../entities/site-menu-title';
import { useLang } from '../hooks/use-lang';
var cls = classNames('share-menu');
export var ShareMenuDefaultProps = {
  items: ['copy-site', 'copy-page', 'facebook', 'twitter', 'linkedin', 'email'],
  iconSize: 32,
  showTitle: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BubbleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(MenuItem)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Button: styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Bubble: styled(EntityBubbleImage)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles)
};
/* @ts-ignore */
export var ShareMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
    items = props.items,
    showTitle = props.showTitle,
    onItemClick = props.onItemClick,
    iconSize = props.iconSize;
  var siteMetadata = useSiteMetadata();
  var title = siteMetadata.title,
    titleTemplate = siteMetadata.titleTemplate;
  var site = useSite();
  var entity = useEntity();
  var subject = titleTemplate && entity.name ? sprintf(titleTemplate, entity.name, site.name) : title;
  var emailUrl = "mailto:?subject=".concat(subject, "&body=").concat(site.url);
  var t = useLang();
  var currentUrl = '';
  if (typeof window !== 'undefined') {
    currentUrl = window.location.href;
  }
  var _a = __read(useCopyToClipboard(site.url), 2),
    siteCopied = _a[0],
    copySite = _a[1];
  var _b = __read(useCopyToClipboard(currentUrl), 2),
    pageCopied = _b[0],
    copyPage = _b[1];
  var _c = __read(React.useState(false), 2),
    pageTick = _c[0],
    setPageTick = _c[1];
  var _d = __read(React.useState(false), 2),
    siteTick = _d[0],
    setSiteTick = _d[1];
  var onSiteCopyClick = function (e) {
    copySite();
    setSiteTick(true);
    setTimeout(function () {
      setSiteTick(false);
    }, 500);
  };
  var onPageCopyClick = function (e) {
    copyPage();
    setPageTick(true);
    setTimeout(function () {
      setPageTick(false);
    }, 500);
  };
  var LABELS = {
    "copy-site": "Copy <b>Website Link</b>",
    "copy-page": "Copy <b>Page Link</b>",
    "facebook": "Share Page on <b>Facebook</b>",
    "twitter": "Share Page on <b>X</b>",
    "linkedin": "Share Page on <b>LinkedIn</b>",
    "email": "Share Page via <b>Email</b>"
  };
  var ON_CLICKS = {
    "copy-site": onSiteCopyClick,
    "copy-page": onPageCopyClick
  };
  var handleClick = function (type) {
    return function (e) {
      if (ON_CLICKS[type]) {
        ON_CLICKS[type](e);
      }
      if (onItemClick) {
        onItemClick(e);
      }
    };
  };
  var shareButtonComponent = function (Component, type, icon) {
    return React.createElement(My.Item, {
      onClick: handleClick(type),
      buttonComponent: function (props) {
        return React.createElement(Component, __assign({
          url: currentUrl
        }, props));
      },
      iconComponent: icon,
      label: LABELS[type],
      iconSize: iconSize
    });
  };
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, showTitle && React.createElement(SiteMenuTitle, null, t('Share Page')), items.map(function (type) {
    // this fragment-branch is less than ideal, but there's no really
    // elegant way to handle this with so many different component setups
    return React.createElement(React.Fragment, {
      key: type
    }, type === "copy-site" && React.createElement(My.Item, {
      onClick: handleClick(type),
      iconSize: iconSize,
      iconComponent: siteTick && TickIconGlyph,
      image: !siteTick && React.createElement(My.Bubble, {
        size: iconSize - 2,
        entity: site
      }),
      label: LABELS[type]
    }), type === "copy-page" && React.createElement(My.Item, {
      onClick: handleClick(type),
      iconSize: iconSize,
      iconComponent: pageTick && TickIconGlyph,
      image: !pageTick && React.createElement(My.Bubble, {
        size: iconSize - 2,
        entity: entity
      }),
      label: LABELS[type]
    }), type === "email" && React.createElement(My.Item, {
      onClick: handleClick(type),
      href: emailUrl,
      iconSize: iconSize,
      iconComponent: EmailFilledIconGlyph,
      label: LABELS[type]
    }), type === 'facebook' && shareButtonComponent(FacebookShareButton, type, FacebookFilledIconGlyph), type === 'twitter' && shareButtonComponent(TwitterShareButton, type, XFilledIconGlyph), type === 'linkedin' && shareButtonComponent(LinkedinShareButton, type, LinkedinFilledIconGlyph));
  }));
});
ShareMenu.cls = cls;
ShareMenu.defaultProps = ShareMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;